<!-- Responsibility: Implement object visual behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<object-visual>
  <span data-fx={ fxKey() } data-size={ sizeKey() }>
    <svg if={ decoPath() } viewBox="0 0 24 24" aria-hidden="true">
      <path d={ decoPath() }></path>
    </svg>
    <span aria-hidden="true">{ visual().emoji }</span>
    <strong if={ !props.iconOnly }>{ label() }</strong>
  </span>

  <script>
    import { getObjectVisual, onObjectEmojiChanged } from '../../engine/object-emoji.js'

    export default {
      onMounted() {
        this.emojiUnsub = onObjectEmojiChanged(() => this.update())
      },

      onUnmounted() {
        this.emojiUnsub?.()
      },

      visual() {
        return getObjectVisual(this.props.name)
      },

      decoPath() {
        return this.visual().decoPath
      },

      fxKey() {
        return this.visual().effect || 'none'
      },

      sizeKey() {
        const size = String(this.props.size ?? 'md').trim().toLowerCase()
        return size === 'sm' || size === 'lg' ? size : 'md'
      },

      label() {
        const raw = String(this.props.name ?? '').trim()
        if (!raw) return ''
        const text = this.props.uppercase ? raw : this.normalizeDisplayCase(raw)
        return this.props.uppercase ? text.toUpperCase() : text
      },

      normalizeDisplayCase(value) {
        const text = String(value ?? '').trim()
        if (!text) return ''
        const hasLower = /[a-z]/.test(text)
        const hasUpper = /[A-Z]/.test(text)
        if (!hasLower && hasUpper && text.length >= 4) {
          return text.toLowerCase().replace(/\b([a-z])/g, (_m, first) => first.toUpperCase())
        }
        return text
      },
    }
  </script>

  <style>
    object-visual > span {
      display: inline-flex;
      align-items: center;
      gap: 0.4em;
      line-height: 1;
      vertical-align: middle;
    }
    object-visual svg {
      width: 1.1em;
      height: 1.1em;
      fill: currentColor;
    }
    object-visual strong {
      font-weight: inherit;
    }
  </style>
</object-visual>
